'use client';
import { useEffect } from 'react';

export default function SWRegister() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;
    // Only register in production — dev HMR + SW caching = hair-pulling pain.
    if (process.env.NODE_ENV !== 'production') return;

    const register = async () => {
      try {
        const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
        // Check for updates every hour.
        setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
      } catch (e) {
        console.warn('SW registration failed:', e);
      }
    };
    register();
  }, []);

  return null;
}
